<div class="div-27"> 📝 {{reportPlaceHolders['LBL_Merchant_Reports']}}
</div>
<div class="report-container pt-5">
    <!-- <div class="report-card" (click)="generateReport(1)">
        <div class="report-icon">📑</div>
        <div class="report-title">{{reportPlaceHolders['LBL_REPORT_TAB_1']}}</div>
        <div class="report-description">{{reportPlaceHolders['LBL_REPORT_TAB_1_EXTRA']}}</div>
    </div>
    <div class="report-card" (click)="generateReport(2)">
        <div class="report-icon">📊</div>
        <div class="report-title">{{reportPlaceHolders['LBL_REPORT_TAB_2']}}</div>
        <div class="report-description">{{reportPlaceHolders['LBL_REPORT_TAB_2_EXTRA']}}</div>
    </div> -->
    <div class="report-card" (click)="generateReport(3)">
        <div class="report-icon">📄</div>
        <div class="report-title">{{reportPlaceHolders['LBL_REPORT_TAB_3']}}</div>
        <div class="report-description">{{reportPlaceHolders['LBL_REPORT_TAB_3_EXTRA']}}</div>
    </div>
</div>